import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

const STRINGS = {
  en: {
    nav_home: "Home",
    nav_about: "About",
    nav_prayer: "Prayer Times",
    nav_announcements: "Announcements",
    nav_gallery: "Gallery",
    nav_events: "Events",
    nav_madrasa: "Madrasa",
    nav_committee: "Committee",
    nav_contact: "Contact",
    nav_admin: "Admin",
    nav_donate: "Donate",
    hero_cta: "View Prayer Times",
    hero_cta2: "Visit Us",
    prayer_heading: "Today's Prayer Times",
    prayer_subhead: "May Allah accept all our prayers",
    fajr: "Fajr", sunrise: "Sunrise", dhuhr: "Dhuhr", asr: "Asr", maghrib: "Maghrib", isha: "Isha", jumuah: "Jumu'ah",
    announcements_heading: "Announcements",
    gallery_heading: "Mosque Gallery",
    gallery_sub: "Moments from our community",
    about_heading: "About the Masjid",
    events_heading: "Upcoming Events",
    no_events: "No events scheduled.",
    madrasa_heading: "Our Madrasa",
    madrasa_timings_label: "Timings",
    committee_heading: "Management Committee",
    committee_subhead: "The dedicated members serving our mosque and community",
    no_committee: "Committee members will be listed soon.",
    contact_heading: "Contact & Donations",
    contact_address: "Address",
    contact_phone: "Phone",
    contact_email: "Email",
    get_directions: "Get Directions",
    open_in_maps: "Open in Google Maps",
    donations_heading: "Donations",
    bank_name: "Bank",
    account_name: "Account Name",
    account_number: "Account No.",
    ifsc: "IFSC",
    upi_id: "UPI",
    footer_rights: "All rights reserved.",
    admin_dashboard: "Admin Dashboard",
    logout: "Logout",
    login: "Login",
    email: "Username",
    password: "Password",
    sign_in: "Sign In",
    welcome_back: "Welcome back",
    admin_subtitle: "Sign in to manage the website",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    cancel: "Cancel",
    add_new: "Add New",
    upload: "Upload",
    no_announcements: "No announcements yet.",
  },
  ta: {
    nav_home: "முகப்பு",
    nav_about: "எங்களைப் பற்றி",
    nav_prayer: "தொழுகை நேரம்",
    nav_announcements: "அறிவிப்புகள்",
    nav_gallery: "புகைப்படங்கள்",
    nav_events: "நிகழ்வுகள்",
    nav_madrasa: "மதரஸா",
    nav_committee: "நிர்வாகக் குழு",
    nav_contact: "தொடர்பு",
    nav_admin: "நிர்வாகி",
    nav_donate: "நன்கொடை",
    hero_cta: "தொழுகை நேரம்",
    hero_cta2: "வருகை தாருங்கள்",
    prayer_heading: "இன்றைய தொழுகை நேரங்கள்",
    prayer_subhead: "அல்லாஹ் நம் தொழுகைகளை ஏற்கட்டும்",
    fajr: "ஃபஜ்ர்", sunrise: "சூரிய உதயம்", dhuhr: "லுஹர்", asr: "அஸர்", maghrib: "மக்ரிப்", isha: "இஷா", jumuah: "ஜும்ஆ",
    announcements_heading: "அறிவிப்புகள்",
    gallery_heading: "மஸ்ஜித் புகைப்பட தொகுப்பு",
    gallery_sub: "எங்கள் சமூகத்தின் தருணங்கள்",
    about_heading: "மஸ்ஜித் பற்றி",
    events_heading: "வரவிருக்கும் நிகழ்வுகள்",
    no_events: "நிகழ்வுகள் எதுவும் இல்லை.",
    madrasa_heading: "எங்கள் மதரஸா",
    madrasa_timings_label: "நேரம்",
    committee_heading: "நிர்வாகக் குழு",
    committee_subhead: "எங்கள் மஸ்ஜித் மற்றும் சமூகத்திற்கு சேவை செய்யும் உறுப்பினர்கள்",
    no_committee: "உறுப்பினர்கள் விரைவில் சேர்க்கப்படும்.",
    contact_heading: "தொடர்பு & நன்கொடை",
    contact_address: "முகவரி",
    contact_phone: "தொலைபேசி",
    contact_email: "மின்னஞ்சல்",
    get_directions: "வழிகாட்டுதல் பெறு",
    open_in_maps: "Google Maps-ல் திற",
    donations_heading: "நன்கொடைகள்",
    bank_name: "வங்கி",
    account_name: "கணக்கின் பெயர்",
    account_number: "கணக்கு எண்",
    ifsc: "IFSC",
    upi_id: "UPI",
    footer_rights: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    admin_dashboard: "நிர்வாக டாஷ்போர்டு",
    logout: "வெளியேறு",
    login: "உள்நுழை",
    email: "பயனர் பெயர்",
    password: "கடவுச்சொல்",
    sign_in: "உள்நுழை",
    welcome_back: "மீண்டும் வரவேற்கிறோம்",
    admin_subtitle: "தளத்தை நிர்வகிக்க உள்நுழையவும்",
    save: "சேமி",
    delete: "நீக்கு",
    edit: "திருத்து",
    cancel: "ரத்து",
    add_new: "புதியதைச் சேர்",
    upload: "பதிவேற்று",
    no_announcements: "இன்னும் அறிவிப்புகள் இல்லை.",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("masjid_lang") || "en");
  useEffect(() => { localStorage.setItem("masjid_lang", lang); }, [lang]);
  const t = (k) => STRINGS[lang]?.[k] ?? STRINGS.en[k] ?? k;
  const toggle = () => setLang((l) => (l === "en" ? "ta" : "en"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
